// extracted by mini-css-extract-plugin
export default {"header-equipment-icon":"header-equipment-icon_ge6Wbj1l","header-equipment-icon--size":"header-equipment-icon--size_JbnWhBjg"};